<template>
  <div class="nextMatch">
    <p class="title">다음경기</p>
    <CountDown v-if="nextGameStatus" :end-date="gameEndDate" />

    <div class="playBox" v-if="nextGameStatus" :class="{hiddenBox: list.length === 1}">
      <button type="button" class="button-prev" @click.stop="toggleAutoplay('prev')"></button>
      <button type="button" class="button-next" @click.stop="toggleAutoplay('next')"></button>
    </div>
    <div class="swiper" v-if="nextGameStatus">
      <swiper ref="bannerSwiper" :options="swiperOption" class="mySwiper">
        <swiper-slide
          v-for="(item, index) in list"
          :key="index"
          class="slide">
          <div class="bgLogo">
            <div class="bannerTitle">
              <img v-if="item.league_name !== 'kleague'" src="@/assets/img/web/ico_facup.png" width="50" alt="banner_img">
              <img v-else src="@/assets/img/web/kleague_ico.png" alt="banner_img" width="80">
            </div>
            <div class="matchBox">
              <div class="info pc">
                <div class="bannerTitle">
                  <img v-if="item.league_name !== 'kleague'" src="@/assets/img/web/ico_facup.png" width="50" alt="banner_img">
                  <img v-else src="@/assets/img/web/kleague_ico.png" alt="banner_img" width="80">
                </div>
                <div class="stadium">{{ item.game_date }}({{ item.game_yoil }}요일)</div>
                <div class="date">{{ item.game_time }}</div>
                <div class="field">
                  {{ item.field_name }}
                  <img src="@/assets/img/icon/icon_map.png" alt="" width="12">
                </div>
              </div>
              <div class="game">
                <div class="emblem">
                  <img :src="getEmblem(item.home_team)" alt="">
                  <p>{{item.home_team_name}}</p>
                </div>
                <div class="vs">
                  <p class="title">VS</p>
                  <p>{{item.type}}</p>
                </div>
                <div class="emblem">
                  <img :src="getEmblem(item.away_team)" alt="">
                  <p>{{item.away_team_name}}</p>
                </div>
              </div>
              <div class="info">
                <div class="stadium">{{ item.game_date }}({{item.game_yoil}})</div>
                <div class="date">{{ item.game_time }}</div>
                <div class="field">
                  {{ item.field_name }}
                  <img src="@/assets/img/icon/icon_map.png" alt="" width="12">
                </div>
              </div>
            </div>
            <a v-if="item.type === '홈'" :href="item.url || '/ticket/reservations'" class="slideLink">예매하기</a>
            <a v-else href="https://www.kleague.com/schedule.do?leagueId=2" class="slideLink" target="_blank">예매하기</a>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div v-else class="noData">
      지난경기가 없습니다.
      <!-- {{this.seasonType ? '지난경기가 없습니다.' : '준비 중입니다'}} -->
    </div>
  </div>
</template>

<script>

import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import CountDown from '@/components/Common/CountDown.vue';
import 'swiper/css/swiper.css'
import {getEmblem} from '@/lib';
import dayjs from "dayjs";
import {leagueName} from "@/lib/match";

export default {
  name: 'NextMatch',
  components: {
    Swiper,
    SwiperSlide,
    CountDown
  },
  props: {
    prevGames: {
      type: Array,
      default: () => []
    },
    nextGames: {
      type: Array,
      default: () => []
    },
    nextGameStatus: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    // this.init()
  },
  data() {
    return{
      swiperOption: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      },
      swiperPause: false,
      list: [],
      gameEndDate: '',
      watchStatus: true,
      seasonType: this.$store.getters['getSeasonType'],
    }
  },
  watch: {
    nextGames: {
      handler: function () {
        this.init()
      },
      deep: true
    }
  },
  methods: {
    getEmblem,
    init () {
      // eslint-disable-next-line vue/no-mutating-props
      // if(!this.seasonType) this.prevGameStatus = this.seasonType;
      if(!this.nextGameStatus || !this.watchStatus) return;
      this.list = this.nextGames.slice(0,5);
      /*this.nextGames.map((item, index) => {
        if (index > this.nextGames.length-5) {
          this.list.unshift(item)
        }
      })*/

      // 현재 다음경기 리스트 중 제일 첫 번째 경기 데이터의 날짜를 뽑아서 사용
      // 첫 번째 다음 경기 당일이 되어서 경기 종료 후 스코어, 관중수 입력이 되어 있을 경우
      // const currentDate = dayjs().format("YYYY-MM-DD");
      // const prevGameDate = this.prevGames[0].game_date.replace(/\./g, '-');

      // 04/08 : 경기일정/결과 테이블에 경기 결과와 관중수 입력 시 다음 경기 데이터가 지난 경기 데이터로 변경됨
      const nextGameDate = this.list[0].game_date.replace(/\./g, '-');
      this.gameEndDate = `${nextGameDate} ${this.list[0].game_time}`;

      // 현재일자와 지난 경기 일자가 동일한지 확인
      /*if(currentDate === prevGameDate) {
        this.gameEndDate = `${prevGameDate} ${this.prevGames[0].game_time}`;
        // 경기 종료 확인 : 경기결과 및 관중 수 데이터 확인
      }else {
        this.gameEndDate = `${nextGameDate} ${this.list[0].game_time}`;
      }*/

      this.list.map((item) => {
        item.league_name = leagueName(item.meet_name);
        if (item.home_team === 'K07') {
          item.type = '홈'
        } else {
          item.type = '어웨이'
        }
        // let datetime = item.game_date + ' ' + item.game_time;
        item.game_time = item.game_time.substring(0, 5);
      })

      this.watchStatus = false;
      this.swiperOption.loop = this.list.length !== 1;
    },
    toggleAutoplay (key) {
      const swiper = this.$refs.bannerSwiper;
      if (swiper) {
        if (key.includes('next')) {
          swiper.$swiper.slideNext();
        } else {
          swiper.$swiper.slidePrev();
        }
      }
    }
  }
}
</script>
<style scoped>
.noData {
  text-align: center;
  padding: 50px 0;
  font-size: 16px;
  color: #999;
}
.hiddenBox {
  visibility: hidden;
}
</style>
